import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as ConfidenceIconSvg } from './confidence-icon.svg';
import { ReactComponent as ExpertiseIconSvg } from './expertise-icon.svg';
import { ReactComponent as FlexibilityIconSvg } from './flexibility-icon.svg';
import { ReactComponent as InnovationIconSvg } from './innovation-icon.svg';
import { ReactComponent as IntegrityIconSvg } from './integrity-icon.svg';
import { ReactComponent as QualityIconSvg } from './quality-icon.svg';
import { ReactComponent as SafetyIconSvg } from './safety-icon.svg';

export const ConfidenceIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ConfidenceIconSvg ref={ref} {...props} />);
export const ExpertiseIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ExpertiseIconSvg ref={ref} {...props} />);
export const FlexibilityIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <FlexibilityIconSvg ref={ref} {...props} />);
export const InnovationIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <InnovationIconSvg ref={ref} {...props} />);
export const IntegrityIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <IntegrityIconSvg ref={ref} {...props} />);
export const QualityIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <QualityIconSvg ref={ref} {...props} />);
export const SafetyIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SafetyIconSvg ref={ref} {...props} />);
